import React from 'react';

// Import ảnh logo QLTM 
// (Lưu ý: Đảm bảo bạn đã chép file logo-qltm.png vào thư mục src/assets/images/ nhé)
import logoQltm from 'assets/images/logo-qltm.png';

// ==============================|| MAIN LOGO ||============================== //

export default function LogoMain() {
  return (
    <img src={logoQltm} alt="QLTM Logo" width="100" style={{ margin: '50px' }} />
  );
}